import { memo } from "react";
import Typography from "@mui/material/Typography";

import {
  formatPatientDisplayName,
  formatPatientPrimaryName,
} from "../helpers/formatCrmCommunicationsDisplay";
import type { CrmPatientSummary } from "../types";

export interface PatientNameCellProps {
  patient: CrmPatientSummary;
  primaryVariant?: "body2" | "subtitle2";
  primaryFontWeight?: number;
}

/**
 * Nome principal + nome oficial em caption (padrão das listas de comunicações).
 */
const PatientNameCell = memo(
  ({
    patient,
    primaryVariant = "body2",
    primaryFontWeight = 400,
  }: PatientNameCellProps) => {
    const primary = formatPatientPrimaryName(
      patient.usualName,
      patient.officialName,
    );
    const officialCaption = formatPatientDisplayName(patient.officialName);

    return (
      <>
        <Typography
          variant={primaryVariant}
          fontWeight={primaryFontWeight}
          color="text.primary"
          component="span"
          display="block"
        >
          {primary}
        </Typography>
        {patient.officialName?.trim() ? (
          <Typography variant="caption" display="block" color="text.secondary">
            {officialCaption}
          </Typography>
        ) : null}
      </>
    );
  },
);

PatientNameCell.displayName = "PatientNameCell";

export default PatientNameCell;
